export const NUMBER_MIN_VALUE = 0.01;
export const NUMBER_MAX_VALUE = Number.MAX_SAFE_INTEGER;
export const DATE_MIN = new Date(2010, 1, 1);
